<template>
  <div>
    <div class="row align-items-center">
      <soha-avatar
        :base-url="$employerImageUrl"
        :image-url="img"
        :size="35"
        :icon="imageIcon"
        :color-hash-input="name"
      />
      <span class="soha-user-name">{{ name }}</span>
      <span class="p-2 soha-date-time">
        {{ toPersianDigits(date) }}
      </span>
      <span class="p-2 soha-date-time">
        {{ toPersianDigits(time) }}
      </span>
    </div>
    <div class="row">
      <div class="soha-text-template" :style="textTemplateStyle">
        <slot name="text-template"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import "@/assets/css/components/resume/resume-timeline-box-item.css";

export default {
  name: "ResumeTabsItem",

  mixins: [UIMixin],

  props: {
    name: String,
    time: String,
    date: String,
    textTemplateBackground: {
      type: String,
      default: "var(--muted-background-color)",
    },
    textTemplateBorderColor: {
      type: String,
      default: "var(--box-border-light-color)",
    },
    imageIcon: String,
    completeBorderRadius: {
      type: Boolean,
      default: true,
    },
    img: null,
  },

  computed: {
    textTemplateStyle() {
      let radius = this.completeBorderRadius ? `5px` : `5px 0 5px 5px`;
      return `border-radius: ${radius};
            background: ${this.textTemplateBackground};
            border: 1px solid ${this.textTemplateBorderColor};`;
    },
  },
};
</script>
